/**
 * Files handed to a run in the Run dialog (AMO-304): which are taken, and
 * each as the base64 the Run request carries.
 *
 * @module components/workflows/RunFiles.logic
 */
import { WORKFLOW_LIMITS, type WorkflowRunFile } from "@amoreg/contracts";

/** The kinds a run's Start step reads: PDF, Word, Excel, CSV and text. */
export const RUN_FILE_ACCEPT = ".pdf,.docx,.xlsx,.csv,.txt,.md,.json,application/pdf,text/csv,text/plain";

/** Why a file is not taken, or null when it is. */
export function runFileProblem(file: { readonly name: string; readonly size: number }, already: number): string | null {
  if (already >= WORKFLOW_LIMITS.runFiles) return `A run takes at most ${WORKFLOW_LIMITS.runFiles} files.`;
  if (file.size > WORKFLOW_LIMITS.runFileBytes) return `"${file.name}" is larger than ${WORKFLOW_LIMITS.runFileBytes / 1024 / 1024} MB.`;
  if (!/\.(pdf|docx|xlsx|csv|txt|md|json)$/iu.test(file.name)) return `"${file.name}" is not a PDF, Word, Excel, CSV or text file.`;
  return null;
}

/** Bytes as base64, in chunks so a large file does not overflow the call stack. */
export function bytesToBase64(bytes: Uint8Array): string {
  let binary = "";
  for (let at = 0; at < bytes.length; at += 0x8000) binary += String.fromCharCode(...bytes.subarray(at, at + 0x8000));
  return btoa(binary);
}

/** A picked file as the Run request carries it. */
export async function runFilePayload(file: File): Promise<WorkflowRunFile> {
  return { name: file.name.slice(0, 255), mimeType: file.type || null, data: bytesToBase64(new Uint8Array(await file.arrayBuffer())) };
}
